import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import TypeContainer from "../../../Entity/Entities/Charge/Type/TypeContainer";
import { FirstDayOfPeriod } from "../../../Entity/Entities/Charge/PaymentOffset/Offsets/FirstDayOfPeriod";
import PeriodContainer from "../../../Entity/Entities/Charge/Period/PeriodContainer";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import Select from "../../Partials/Material/Select";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "../../Partials/Material/TextField";
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';
import Switch from '@material-ui/core/Switch';
import Formatter from "../../../Localization/Formatter";
import { ChargeTypeCreate } from "../../Partials/Dialog/ChargeTypeCreate";
import Constants from "../../../Action/Constants";
import { CoachNewCounterpartyDialog } from "../../Partials/Dialog/CoachNewCounterpartyDialog";
import Searchbar from "../Searchbar/Searchbar";
import { Company } from "../../../Entity/Entities/Company/Company";
import { Person } from "../../../Entity/Entities/Person/Person";
import { PersonInterface } from "../../../Entity/Entities/Person/PersonInterface";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";

export class ChargeTemplateCreate extends Component {
  public state = {
    isDefault: this.props.isDefault,
    amount: "",
    currency: this.props.app.settings.user.currency.getCurrencyId(),
    repeatPeriod: this.props.selectedType === TypeContainer.pickIdFromLabel("Deposit") ? PeriodContainer.pickIdFromLabel("once") : PeriodContainer.pickIdFromLabel("monthly"),
    description: this.props.description ? this.props.description : "",
    paymentOffset: FirstDayOfPeriod.value,
    type: this.props.selectedType ? this.props.selectedType : TypeContainer.pickIdFromLabel("Other_receivable"),
    dueDateFirstPayment: this.props.firstDate !== undefined  ? this.props.firstDate : new Date(),
    dueDateFirstPaymentWasManuallyChanged: false,
    firstDate: this.props.firstDate !== undefined ? this.props.firstDate : new Date(),
    endDate: this.props.endDate ? this.props.endDate : null,
    isCreateChargeTypePopupOpen: false,
    isPaidDirectlyToOwner: this.props.existingChargeTemplates?.length > 0 ?
                           this.props.existingChargeTemplates.find(chargeTemplate => chargeTemplate?.isCollective)?.isPaidDirectlyToOwner 
                           : false,
    isForContract: this.props.entity === "contract",
    isForUnit: this.props.entity === "unit",
    isForProperty: this.props.entity === "property",
    selectedCounterparty: !!this.props.contact ? this.props.contact : !!this.props.company ? this.props.company :  null,
    isCollective: typeof this.props.isCollective !== "undefined" ? this.props.isCollective :
                    (this.props.entity === "contract" || this.props.isDefault) && this.props.selectedType !== TypeContainer.pickIdFromLabel("Deposit") ? true : false,
    repeatPeriodWasManuallyChanged: false,
    isChargeTemplatesWithDifferentDummyPayPopupOpen: false,
    openCoachCreateNewCounterparty: false
  };

  constructor(public props) {
    super(props);
  }

  public selectDate = (momentDate: any, identifier: string): any => {
    const date = !!momentDate && typeof momentDate.toDate === "function" ? momentDate.toDate() : momentDate;

    this.setState({
      [identifier]: date,
      dueDateFirstPaymentWasManuallyChanged: identifier === "dueDateFirstPayment" ? true : this.state.dueDateFirstPaymentWasManuallyChanged,
      hasModifiedData: true
    }, () => {
      if (identifier === "firstDate") {
        this.setState({
          dueDateFirstPayment: date
        });
      }
    });
  }

  public onCancel = (): any => {
    if (typeof this.props.onCancel !== "undefined") {
      this.props.onCancel.call(this);
    }
  }

  public onSave = (): any => {
    const payload: any = {
      amount: this.state.amount === "" ? "" : parseFloat(parseFloat(String(Formatter.deleteExtraSpace(this.state.amount)).replace(",", ".")).toFixed(2)),
      currency: this.state.currency,
      currencyId: this.state.currency,
      repeatPeriod: this.state.repeatPeriod,
      repeatPeriodId: this.state.repeatPeriod,
      description: this.state.description,
      paymentOffset: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? FirstDayOfPeriod.value : this.state.paymentOffset,
      type: this.state.type,
      dueDateFirstPayment: this.state.dueDateFirstPayment,
      firstDate: this.state.firstDate,
      endDate: this.state.endDate,
      isDefault: this.state.isDefault,
      isPaidDirectlyToOwner: this.state.isPaidDirectlyToOwner,
      isCollective: this.state.isCollective
    };

    if (this.state.selectedCounterparty instanceof Person) {
      payload.contactId = this.state.selectedCounterparty?.id;
      payload.companyId = null;
    }

    if (this.state.selectedCounterparty instanceof Company) {
      payload.companyId = this.state.selectedCounterparty?.id;
      payload.contactId = null;
    }

    if (typeof this.props.onSave === "function") {
      this.props.onSave.call(this, {...payload}, this.props.onSaveCallback);
    }
  }

  public renderDueDateField = (): any => {
    // increment or decrement Data depending on selector "Due date"
    const oneDay: number = 86400000; // one day in miliseconds
    let changePeriodDate: Date;

    // when user changes payment offset we should
    // change due date for first payment if it is not manully changed
    if (!this.state.dueDateFirstPaymentWasManuallyChanged && !!this.props.firstDate) {
      changePeriodDate = new Date(this.props.firstDate.getTime() + oneDay * this.state.paymentOffset);
      this.state.dueDateFirstPayment = changePeriodDate;
    }

    if (PeriodContainer.pickIdFromLabel("once") === this.state.repeatPeriod) {

      return (
        <DatePickerComponent
          {...this.props}
          className="scroll-to-dueDateFirstPayment"
          label={this.trans("dialog/defaultchargetemplates-field/duedatepayment-label")}
          initialDate={this.state.dueDateFirstPayment}
          onChange={date => this.selectDate(date, "dueDateFirstPayment")}
          clearButton={true}
          error={this.getErrorFor("dueDateFirstPayment")}
          height={"50px"}
        />
      );
    }

    return (
      <div>
        <DatePickerComponent
          {...this.props}
          className="scroll-to-dueDateFirstPayment"
          label={this.trans("dialog/defaultchargetemplates-field/duedatefirstpayment-label")}
          initialDate={this.state.dueDateFirstPayment}
          onChange={date => this.selectDate(date, "dueDateFirstPayment")}
          clearButton={true}
          error={this.getErrorFor("dueDateFirstPayment")}
          height={"50px"}
        />
      </div>
    );
  }

  public addChargeType = (chargeType: object, callback?): void => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_CHARGE_TYPE_CREATE_START,
        payload: {
          chargeType: chargeType
        },
        onSuccess: (chargeType) => {
          this.setState({
            type: chargeType?.id,
            isCreateChargeTypePopupOpen: false,
            hasModifiedData: true,
            isSaving: false,
          });

          if (typeof callback === "function") {
            callback();
          }
        },
        onError: () => {
          this.setState({
            hasModifiedData: true,
            isSaving: false
          });
        }
      });
    });
  }

  public closeChargeTypeCreateDialog = (): void => {
    this.props.dispatch({
      type: Constants.GLOBAL_CHARGE_TYPE_CREATE_CLEAR,
    });

		this.setState({isCreateChargeTypePopupOpen: false});
  }

  public setType = (event) => {
    const type = event.target.value;

    if (!this.state.repeatPeriodWasManuallyChanged) {
      if (type === TypeContainer.pickIdFromLabel("Deposit")) {
        return this.setState({
          type: type,
          repeatPeriod: PeriodContainer.pickIdFromLabel("once"),
          isCollective: false,
        });
      } else {
        return this.setState({
          type: type,
          repeatPeriod: PeriodContainer.pickIdFromLabel("monthly"),
          isCollective: true,
        });
      }
    } else {
      return this.setState({
        type: type,
        isCollective: this.state.repeatPeriod === PeriodContainer.pickIdFromLabel("once") ? false : true,
      });
    }
  }

  public setRepeatPeriod = (event) => {
    const period = event.target.value;

    return this.setState({
      repeatPeriod: period,
      repeatPeriodWasManuallyChanged: true,
      isCollective: period === PeriodContainer.pickIdFromLabel("once") ? false : true,
    });
  }

  public switchIsPaidDirectlyToOwner = () => {
    this.setState({
      isPaidDirectlyToOwner: !this.state.isPaidDirectlyToOwner
    });
  }

  public changeIsCollective = () => {
    this.setState({
      isCollective: !this.state.isCollective
    });
  }

  public selectCounterparty = (entity: CompanyInterface | PersonInterface): void => {
    this.setState({
      selectedCounterparty: entity,
      hasModifiedData: true
    });
  }

  public clearCounterparty = (): void => {
    this.setState({
      selectedCounterparty: null,
      hasModifiedData: true
    });
  }

  public render() {

    return (
      <div>
        { this.props.showInformationText &&
          <div className="hint-styles-dialog" style={{color: "#333", margin: "0px"}}>
            {this.trans("dialog/chargetemplate-info1")}
          </div>
        }
        { this.props.isDefault &&
          <div className="hint-styles-dialog" style={{color: "#333", margin: "0px"}}>
            {this.trans("dialog/defaultchargetemplate-info1")}
          </div>
        }
        <div>
          <div style={{display: "flex", justifyContent: "flex-start", marginBottom: "-10px"}}>
            <div style={{display: "flex", flexDirection: "column", width: "50%", marginRight: "15px"}}>
              <TextField
                autoComplete="off"
                // id="amount"
                // name="amount"
                className="form-element scroll-to-amount"
                type="text"
                label={this.trans("dialog/defaultchargetemplates-field/amount-label")}
                value={this.state.amount}
                onChange={this.sync.bind(this, this.syncronizers.EVENT, "amount")}
                autoFocus={true}
                variant="standard"
                error={!!this.getErrorFor("amount")}
              />
              {!!this.getErrorFor("amount") && <div className="component-error-text">{this.getErrorFor("amount")}</div>}
            </div>

            <Select
              className="form-element full-size form-input scroll-to-currency correct-label-position"
              error={this.getErrorFor("currency")}
              style={{width: "50%"}}
              value={this.state.currency}
              onChange={this.sync.bind(this, this.syncronizers.CURRENCY)}
              htmlFor="currency"
              label={this.trans("dialog/defaultchargetemplates-field/currency-label")}
              name="currency" 
              id="currency"
            >
              {this.getCurrencySelectboxes()}
            </Select>
          </div>

          <Select
            className="form-element full-size form-input scroll-to-type correct-label-position"
            error={this.getErrorFor("type")}
            value={this.state.type}
            onChange={this.setType}
            htmlFor="type"
            label={this.trans("dialog/defaultchargetemplates-field/type-label")}
            name="type" 
            id="type"
          >
            {
              TypeContainer.getChargeTypesForChargeTemplates(this.props.entity).filter(chargeType => {
                if (!!this.state.type && chargeType?.removed && (chargeType?.id === this.state.type)) {
                  return true;
                }

                if (chargeType?.removed) {
                  return false;
                }

                return true;
              })
              .map((type, index) => {
                return (
                  <MenuItem key={`chargeType-${index}`} value={type.id} disabled={(type.id === -1 || type.id === -2)}>{`${type.id === -1 || type.id === -2 ? type.label : Formatter.checkTranslationType(this.trans(type?.label, {}, "", type?.system), type?.label, type?.system)}`}</MenuItem>
                );
              })
            }
            {/* {
              <MenuItem
                className="add-charge-type-div button-add-wrapper"
              >
                <Button
                  style={{width: "100%"}}
                  className="add-charge-type-button color-button-add"
                  color="primary"
                  onClick={() => this.setState({isCreateChargeTypePopupOpen: true})}
                >
                  {this.trans("dialog/chargetype-button/newchargetype")}
                </Button>
              </MenuItem>
            } */}
          </Select>

          <Select
            className="form-element full-size form-input scroll-to-repeat-period correct-label-position"
            error={this.getErrorFor("repeat-period")}
            value={this.state.repeatPeriod}
            onChange={this.setRepeatPeriod}
            htmlFor="repeatPeriod"
            label={this.trans("dialog/defaultchargetemplates-field/period-label")}
            name="repeatPeriod" 
            id="repeatPeriod"
          >
            {this.getRepeatPeriodSelectboxes()}
          </Select>

          {
            this.state.isForContract && (
              <Select
                className="form-element full-size form-input scroll-to-payment-offset correct-label-position"
                error={this.getErrorFor("payment-offset")}
                value={this.state.paymentOffset}
                onChange={this.sync.bind(this, this.syncronizers.PAYMENT_OFFSET)}
                htmlFor="paymentOffset"
                label={this.trans("dialog/defaultchargetemplates-field/paymentoffset-label")}
                name="paymentOffset" 
                id="paymentOffset"
              >
                {this.getPaymentOffsetSelectboxes()}
              </Select>
            )
          }

          {
            !this.state.isDefault && (
              <div className="search-bar-container" style={{margin: "-20px 0 -10px 0"}}>
                <Searchbar
                  {...this.props}
                  id="selectedCounterparty"
                  className={"scroll-to-counterpartyId"}
                  height={400}
                  // floatingLabelText={labelText}
                  floatingLabelText={TypeContainer.pickChargeClassIdFromId(this.state.type) === ChargeClassContainer.pickIdFromLabel("Receivable") ? this.trans("section/charge-field/from-label") : this.trans("section/charge-field/to-label")}
                  allResults={true}
                  objectField={true}
                  onChange={this.selectCounterparty}
                  onClear={this.clearCounterparty}
                  selectedEntity={this.state.selectedCounterparty}
                  searchParameter={"contactsSearch"}
                  error={this.getErrorFor("counterpartyId")}
                  disabled={!!this.props.isDisabled}
                  searchText={this.state.selectedCounterparty ? `${this.state.selectedCounterparty?.nameOfEntity}, ${this.state.selectedCounterparty?.displayName}` : null}
                  styleInModal={"pick-object-modal"}
                  createButton={"dropdown-button/newcounterparty"}
                  openCoachCreateNewEntity={() => {
                    this.setState({
                      openCoachCreateNewCounterparty: true,
                      selectedCounterparty: null
                    })}
                  }
                />
              </div>
            )
          }

          {this.state.isForContract && this.renderDueDateField()}

          {!this.state.isDefault && !this.state.isForContract && (
            <DatePickerComponent
              {...this.props}
              className="scroll-to-firstDate"
              label={this.trans("dialog/defaultchargetemplates-field/firstdate-label")}
              initialDate={this.state.firstDate}
              onChange={date => this.selectDate(date, "firstDate")}
              clearButton={true}
              error={this.getErrorFor("firstDate")}
              height={"50px"}
            />
          )}

          <TextField
            autoComplete="off"
            className="form-element full-size scroll-to-description"
            type="text"
            label={this.trans("dialog/defaultchargetemplates-field/description-label") + this.trans("field/optional")}
            value={this.state.description}
            onChange={this.sync.bind(this, this.syncronizers.EVENT, "description")}
            variant="standard"
            error={!!this.getErrorFor("description")}
          />
          {!!this.getErrorFor("description") && <div className="component-error-text">{this.getErrorFor("description")}</div>}

          {/* {
            (this.state.isForContract || this.state.isDefault) &&
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.isPaidDirectlyToOwner}
                  onChange={this.switchIsPaidDirectlyToOwner}
                  color="primary"
                />
              }
              label={this.trans("dialog/defaultchargetemplates-field/paiddirectlytoowner-label")}
            />
          } */}

          {
            this.state.isForContract && (
              <div>
                <FormControlLabel
                  control={
                    <Switch
                      checked={!this.state.isCollective}
                      onChange={this.changeIsCollective}
                      color="primary"
                    />
                    }
                  label={this.trans("dialog/defaultchargetemplates-label/collate")}
                />
              </div>
            )
          }
        </div>

        <DialogActions>
          <div className="button-container">
            <Button
              color="primary"
              onClick={this.onCancel}
            >
              {!!this.props.negativeButtonLabel ? this.props.negativeButtonLabel : this.trans("dialog-button/cancel")}
            </Button>

            {this.props.additionalButton}

            <Button
              variant="contained"
              color="primary"
              onClick={this.onSave}
              disabled={this.props.chargeTemplateCreate && this.props.chargeTemplateCreate.isFetching === true}
            >
              {!!this.props.positiveButtonLabel ? this.props.positiveButtonLabel : this.trans("dialog-button/create")}
            </Button>
          </div>
        </DialogActions>

        <PromptDialog
          {...this.props}
          title={this.trans("dialog/chargetype-title")}
          content={
            <ChargeTypeCreate
              {...this.props}
              onSaveType={this.addChargeType}
              onCancelType={this.closeChargeTypeCreateDialog}
            />
          }
          openLeavePrompt={this.state.isCreateChargeTypePopupOpen}
          withoutDefaultDilaogButtons={true}
          onClose={this.closeChargeTypeCreateDialog}
        />

        <CoachNewCounterpartyDialog
          {...this.props}
          openCoachCreateNewCounterparty={this.state.openCoachCreateNewCounterparty}
          onCloseCounterpartyCoach={entity => {
            if(entity) {
              this.setState({
                openCoachCreateNewCounterparty: false            
              }, () => {this.selectCounterparty(entity)})
            } else {
              this.setState({
                openCoachCreateNewCounterparty: false  
              })          
            }
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes,
    component: state.chargeTemplateCreate,
    chargeTemplateCreate: state.chargeTemplateCreate,
    chargeTemplateUpdate: state.chargeTemplateUpdate,
  };
};

export default connect(mapStateToProps)(
  ChargeTemplateCreate
);
